(function () {
//This module is the main entry point for the website's JavaScript functionality.
// import "regenerator-runtime/runtime.js";
// import "core-js/actual";
//This module handles the internationalization (i18n) functionality for the website.
//This module contains the translations for the G.U.C. Coaching website in multiple languages.
const $ccc968e822ac6427$export$150b732325d14d04 = {
    en: {
        title: `G.U.C. Coaching`,
        about: "About",
        services: "Services",
        stats: "Stats",
        contact: "Contact",
        heroTitle: "Growing Under Control",
        heroSubtitle: "Elite training. Tailored nutrition. Next-level results.",
        heroCTA: "Start Transformation",
        aboutTitle: "About Me",
        aboutText: "I'm a certified personal trainer with over 8 years of experience helping clients build muscle, burn fat, and master discipline. My mission is to transform not only physiques but lives \u2014 with proven methods, tailored support, and relentless energy.",
        servicesTitle: "Services",
        lifestyleCoaching: "Personal Training",
        lifestyleText: "Optimize your habits, manage stress, and create a routine that fits your lifestyle. Daily success starts here.",
        onlineCoach: "Online Coaching",
        onlineCoachingText: "Get tailored supplement advice to boost performance, recovery, and overall health \u2014 fully remote and effective.",
        workoutPlans: "Workout Plans",
        workoutText: "Custom strength and hypertrophy plans built around your goals and physique. Train smarter, grow stronger.",
        mealPlan: "Meal Plans",
        mealPlansText: "Science-backed meal plans for fat loss, muscle building, or stepping on stage. Fuel your goals the right way.",
        nutritionCoaching: "Supplement Guidance & Nutrition Coaching",
        nutritionText: "Your roadmap to better results. Expert nutrition and supplement strategies for fat loss, muscle gain, or prep.",
        fitRecipes: "Fit Recipes",
        fitRecipesText: "Easy-to-follow recipe plans for your fitness goals. Healthy eating doesn\u2019t have to be boring \u2014 or complicated.",
        statsTitle: "My Results",
        clients: "Clients Transformed",
        experience: "Years Experience",
        competitions: "Competitions Coached",
        reviews: "5-Star Reviews",
        statsText: "These numbers reflect more than progress \u2014 they represent dedication, transformation, and unstoppable momentum.",
        contactTitle: "Contact",
        yourName: "Your Name",
        yourPhone: "Your Phone Number",
        yourEmail: "Your Email",
        yourMessage: "Your Message",
        sendMessage: "Send Message",
        footerText: "All rights reserved.",
        footerBuilt: "Built with \u2764\uFE0F by",
        lifestyle: "Your Personalized Path to Strength, Structure & Results",
        lifestyleModalText: `Unlock your full potential through personalized one-on-one coaching that adapts to your lifestyle, experience level, and goals.
Together, we\u{2019}ll build a sustainable routine that maximizes your performance, boosts your confidence, and helps you manage stress more effectively.
From tailored training plans to daily habit guidance, I\u{2019}ll help you stay accountable and focused \u{2014} because true progress starts with structure.
Daily wins, long-term transformation. Let\u{2019}s get to work.`,
        onlineCoaching: "Remote Coaching. Real Results.",
        onlineCoachingModalText: `No matter where you are, you\u{2019}ll get the expert guidance and support you need to stay on track and reach your fitness goals.
With structured check-ins, adaptive plans, and personal accountability, online coaching brings the gym to your lifestyle.
We\u{2019}ll combine strategic adjustments with consistent motivation so you never feel lost \u{2014} just stronger, smarter, and more in control every week.`,
        workouts: "Tailored Workout Plans That Build Real Strength",
        workoutsModalText: `Get the structure and strategy you need to make every training session count.
Whether you\u{2019}re training for performance, aesthetics, or personal achievement, your custom workout plan will reflect your goals, time, and body type.
We\u{2019}ll optimize your splits, rep ranges, and progression \u{2014} all designed to help you grow, not plateau. Results are earned, not guessed.`,
        mealPlans: "Custom Meal Plans for Fueling Transformation",
        mealPlansModalText: `Nutrition should support your life \u{2014} not complicate it. 
With science-based meal plans designed around your goal (fat loss, muscle gain, or competition prep), you\u{2019}ll get clarity and confidence in the kitchen.
Expect practical, sustainable meals that fuel energy, recovery, and progress without extreme diets or restriction.`,
        nutritions: "Supplement & Nutrition Coaching with Purpose",
        nutritionsModalText: `Navigating the supplement world and dialing in your macros doesn\u{2019}t have to be overwhelming.
With my coaching, you\u{2019}ll get evidence-based recommendations that enhance performance, recovery, and overall wellness.
From understanding timing and dosage to tailoring your intake to your training and metabolism \u{2014} I\u{2019}ll guide you every step of the way.`,
        recipes: "Fit-Friendly Recipes That Actually Taste Good",
        recipesModalText: `Eating healthy should be simple, enjoyable, and aligned with your fitness journey.
These recipe solutions are crafted to support your physique goals while keeping flavor on the plate.
From quick prep meals to creative twists on classics, you\u{2019}ll have access to easy, macro-friendly recipes that fuel your progress \u{2014} and your cravings.`
    },
    hu: {
        title: "G.U.C. Coaching",
        about: "R\xf3lam",
        services: "Szolg\xe1ltat\xe1sok",
        stats: "Eredm\xe9nyek",
        contact: "Kapcsolat",
        heroTitle: "Growing Under Control",
        heroSubtitle: "Professzion\xe1lis edz\xe9s. Szem\xe9lyre szabott t\xe1pl\xe1lkoz\xe1s. L\xe1tv\xe1nyos eredm\xe9nyek.",
        heroCTA: "Kezdd el az \xe1talakul\xe1st",
        aboutTitle: "R\xf3lam",
        aboutText: "Tan\xfas\xedtott szem\xe9lyi edz\u0151 vagyok, t\xf6bb mint 8 \xe9v tapasztalattal. Seg\xedtek az \xfcgyfeleknek izmot \xe9p\xedteni, zs\xedrt \xe9getni, \xe9s elsaj\xe1t\xedtani a fegyelmet. K\xfcldet\xe9sem, hogy ne csak a testeket, hanem \xe9leteket is \xe1talak\xedtsak \u2013 bizony\xedtott m\xf3dszerekkel, szem\xe9lyre szabott t\xe1mogat\xe1ssal \xe9s f\xe1radhatatlan energi\xe1val.",
        servicesTitle: "Szolg\xe1ltat\xe1sok",
        lifestyleCoaching: "Szem\xe9lyi Edz\xe9s",
        lifestyleText: "Optimaliz\xe1ld a szok\xe1saidat, kezeld a stresszt, \xe9s alak\xedts ki egy \xe9letst\xedlusodhoz ill\u0151 rutint. A napi siker itt kezd\u0151dik.",
        onlineCoach: "Online Tan\xe1csad\xe1s",
        onlineCoachingText: "Szem\xe9lyre szabott t\xe1pl\xe1l\xe9kkieg\xe9sz\xedt\u0151 tan\xe1csad\xe1s a teljes\xedtm\xe9ny, regener\xe1ci\xf3 \xe9s eg\xe9szs\xe9g t\xe1mogat\xe1s\xe1ra \u2013 teljesen online.",
        workoutPlans: "Edz\xe9stervek",
        workoutText: "Egy\xe9ni er\u0151- \xe9s izomt\xf6meg-n\xf6vel\u0151 edz\xe9stervek, a c\xe9ljaidhoz \xe9s testedhez igaz\xedtva. Edz okosan, fejl\u0151dj hat\xe9konyan.",
        mealPlan: "\xc9trendek",
        mealPlansText: "Tudom\xe1nyos alap\xfa \xe9trendek fogy\xe1shoz, izom\xe9p\xedt\xe9shez vagy versenyfelk\xe9sz\xfcl\xe9shez. T\xe1pl\xe1ld helyesen a c\xe9ljaidat.",
        nutritionCoaching: "T\xe1pl\xe1l\xe9kkieg\xe9sz\xedt\u0151- & T\xe1pl\xe1lkoz\xe1si Tan\xe1csad\xe1s",
        nutritionText: "\xdatmutat\xf3 a jobb eredm\xe9nyekhez: profi \xe9trend- \xe9s kieg\xe9sz\xedt\u0151-strat\xe9gi\xe1k fogy\xe1shoz, izom\xe9p\xedt\xe9shez vagy felk\xe9sz\xfcl\xe9shez.",
        fitRecipes: "Fitt Receptek",
        fitRecipesText: "Egyszer\u0171, c\xe9lorient\xe1lt recepttervek az eg\xe9szs\xe9ges \xe9letm\xf3dhoz. Az eg\xe9szs\xe9ges \xe9tkez\xe9s lehet finom \xe9s \xe9lvezetes is.",
        statsTitle: "Eredm\xe9nyeim",
        clients: "\xc1talak\xedtott \xfcgyfelek",
        experience: "\xc9v tapasztalat",
        competitions: "Edzett versenyz\u0151k",
        reviews: "5 csillagos \xe9rt\xe9kel\xe9s",
        statsText: "Ezek a sz\xe1mok t\xf6bbet jelentenek, mint puszta fejl\u0151d\xe9s \u2013 elk\xf6telezetts\xe9get, \xe1talakul\xe1st \xe9s meg\xe1ll\xedthatatlan lend\xfcletet k\xe9pviselnek.",
        contactTitle: "Kapcsolat",
        yourName: "Neved",
        yourEmail: "Email c\xedmed",
        yourPhone: "Telefonsz\xe1mod",
        yourMessage: "\xdczeneted",
        sendMessage: "\xdczenet k\xfcld\xe9se",
        footerText: "Minden jog fenntartva.",
        footerBuilt: "\u2764\uFE0F-el k\xe9sz\xedtette:",
        lifestyle: "Szem\xe9lyre szabott \xfat az er\u0151h\xf6z, strukt\xfar\xe1hoz \xe9s eredm\xe9nyekhez",
        lifestyleModalText: `Hozd ki magadb\xf3l a legt\xf6bbet egy\xe9ni, szem\xe9lyre szabott edz\xe9sprogrammal, amely igazodik az \xe9letm\xf3dodhoz, szintjeidhez \xe9s c\xe9ljaidhoz.
K\xf6z\xf6sen kialak\xedtunk egy fenntarthat\xf3 rutint, amely n\xf6veli a teljes\xedtm\xe9nyed, er\u{151}s\xedti az \xf6nbizalmad, \xe9s seg\xedt hat\xe9konyabban kezelni a stresszt.
Az egy\xe9nre szabott edz\xe9stervekt\u{151}l a napi szok\xe1sok optimaliz\xe1l\xe1s\xe1ig v\xe9gig t\xe1mogatlak \u{2013} mert az igazi fejl\u{151}d\xe9s strukt\xfar\xe1val kezd\u{151}dik.
Napi sikerekb\u{151}l lesz a tart\xf3s \xe1talakul\xe1s. V\xe1gjunk bele!`,
        onlineCoaching: "Online t\xe1mogat\xe1s. Val\xf3di eredm\xe9nyek.",
        onlineCoachingModalText: `B\xe1rhol is vagy, megkapod a szak\xe9rt\u{151}i t\xe1mogat\xe1st, amivel nemcsak tartani tudod a c\xe9ljaidat, hanem t\xfal is sz\xe1rnyalhatod azokat.
Struktur\xe1lt visszajelz\xe9sek, szem\xe9lyre szabott tervm\xf3dos\xedt\xe1sok \xe9s folyamatos motiv\xe1ci\xf3 seg\xedtik az utadat.
Az online coaching r\xe9v\xe9n az edz\xe9s ott lesz veled, ahol csak vagy \u{2014} f\xf3kusz\xe1ltan, hat\xe9konyan, eredm\xe9nyesen.`,
        workouts: "Egy\xe9ni edz\xe9stervek val\xf3di fejl\u0151d\xe9shez",
        workoutsModalText: `Megkapod a strukt\xfar\xe1t \xe9s strat\xe9gi\xe1t, amire sz\xfcks\xe9ged van ahhoz, hogy minden edz\xe9s sz\xe1m\xedtson.
Ak\xe1r eszt\xe9tikai, ak\xe1r teljes\xedtm\xe9nyc\xe9lokat t\u{171}zt\xe9l ki, az edz\xe9sterved a testedhez, id\u{151}dh\xf6z \xe9s c\xe9ljaidhoz lesz igaz\xedtva.
Split, ism\xe9tl\xe9ssz\xe1m, progresszi\xf3 \u{2013} minden \xfagy lesz tervezve, hogy ne stagn\xe1lj, hanem fejl\u{151}dj.`,
        mealPlans: "Szem\xe9lyre szabott \xe9trendek az \xe1talakul\xe1shoz",
        mealPlansModalText: `A t\xe1pl\xe1lkoz\xe1s legyen a t\xe1mogat\xf3d, ne az ellens\xe9ged. 
Olyan tudom\xe1nyos alap\xfa \xe9trendeket kapsz, amelyek pontosan a te c\xe9ljaidhoz igazodnak: legyen sz\xf3 zs\xedr\xe9get\xe9sr\u{151}l, izomn\xf6vel\xe9sr\u{151}l vagy versenyfelk\xe9sz\xfcl\xe9sr\u{151}l.
Egyszer\u{171}, fenntarthat\xf3, \xedzletes \u{2013} nincs t\xf6bb\xe9 k\xe1osz a konyh\xe1ban, csak tiszta ir\xe1ny.`,
        nutritions: "T\xe1pl\xe1lkoz\xe1si \xe9s kieg\xe9sz\xedt\u0151 tan\xe1csad\xe1s, c\xe9llal",
        nutritionsModalText: `Nem kell elveszned a t\xe1pl\xe1l\xe9kkieg\xe9sz\xedt\u{151}k \xe9s makr\xf3k vil\xe1g\xe1ban.
Seg\xedtek eligazodni az adagol\xe1sban, id\u{151}z\xedt\xe9sben \xe9s a szem\xe9lyre szabott be\xe1ll\xedt\xe1sokban is \u{2013} edzetts\xe9gi szintedhez \xe9s \xe9letm\xf3dodhoz igaz\xedtva.
C\xe9lzott t\xe1mogat\xe1s a teljes\xedtm\xe9nyedhez, regener\xe1ci\xf3dhoz \xe9s eg\xe9szs\xe9gedhez.`,
        recipes: "Eg\xe9szs\xe9ges receptek, amiket sz\xedvesen eszel is",
        recipesModalText: `Az eg\xe9szs\xe9ges \xe9tkez\xe9s legyen egyszer\u{171} \xe9s \xe9lvezetes \u{2013} nem unalmas \xe9s bonyolult.
Ezek a receptek t\xe1mogatj\xe1k a fizikai c\xe9ljaidat, mik\xf6zben finomak, gyorsan elk\xe9sz\xedthet\u{151}k \xe9s k\xf6nnyen beilleszthet\u{151}k a mindennapokba.
Makr\xf3bar\xe1t fog\xe1sok, amik nem \xe1ldozz\xe1k fel az \xedzt a c\xe9l olt\xe1r\xe1n.`
    },
    nl: {
        title: "G.U.C. Coaching",
        about: "Over Mij",
        services: "Diensten",
        stats: "Resultaten",
        contact: "Contact",
        heroTitle: "Growing Under Control",
        heroSubtitle: "Elite training. Gepersonaliseerde voeding. Resultaten op een hoger niveau.",
        heroCTA: "Start je Transformatie",
        aboutTitle: "Over Mij",
        aboutText: "Ik ben een gecertificeerde personal trainer met meer dan 10 jaar ervaring. Ik help klanten met spieropbouw, vetverlies en het ontwikkelen van discipline. Mijn missie is om niet alleen lichamen, maar levens te transformeren \u2014 met bewezen methoden, persoonlijke begeleiding en eindeloze energie.",
        servicesTitle: "Diensten",
        lifestyleCoaching: "Persoonlijke training",
        lifestyleText: "Optimaliseer je gewoontes, beheer stress en bouw een routine die past bij jouw leven. Dagelijks succes begint hier.",
        onlineCoach: "Online Coaching",
        onlineCoachingText: "Persoonlijk supplementadvies voor betere prestaties, herstel en gezondheid \u2013 volledig online en effectief.",
        workoutPlans: "Trainingsschema\u2019s",
        workoutText: "Persoonlijke kracht- en spieropbouwschema\u2019s afgestemd op jouw lichaam en doelen. Train slimmer, groei sterker.",
        mealPlan: "Maaltijdschema\u2019s",
        mealPlansText: "Wetenschappelijk onderbouwde maaltijdschema\u2019s voor vetverlies, spieropbouw of wedstrijdvoorbereiding. Voed je doelen op de juiste manier.",
        nutritionCoaching: "Supplementadvies & Voedingscoaching",
        nutritionText: "Jouw route naar betere resultaten. Voedings- en supplementstrategie\xebn van experts voor vetverlies, spiergroei of prep.",
        fitRecipes: "Fit Recepten",
        fitRecipesText: "Makkelijke, doelgerichte recepten voor jouw fitnesstraject. Gezond eten hoeft niet saai of ingewikkeld te zijn.",
        statsTitle: "Mijn Resultaten",
        clients: "Getransformeerde Klanten",
        experience: "Jaren Ervaring",
        competitions: "Begeleide Wedstrijden",
        reviews: "5-sterren Beoordelingen",
        statsText: "Deze cijfers staan voor meer dan vooruitgang \u2014 ze vertegenwoordigen toewijding, transformatie en niet te stoppen motivatie.",
        contactTitle: "Contact",
        yourName: "Je Naam",
        yourEmail: "Je E-mailadres",
        yourPhone: "Je Telefoonnummer",
        yourMessage: "Je Bericht",
        sendMessage: "Bericht Versturen",
        footerText: "Alle rechten voorbehouden.",
        footerBuilt: "Gemaakt met \u2764\uFE0F door",
        lifestyle: "Jouw Persoonlijke Route naar Kracht, Structuur & Resultaat",
        lifestyleModalText: `Ontgrendel je volledige potentieel met gepersonaliseerde \xe9\xe9n-op-\xe9\xe9n coaching die aansluit bij jouw levensstijl, ervaringsniveau en doelen.
Samen bouwen we een duurzaam schema dat je prestaties maximaliseert, je zelfvertrouwen vergroot en helpt om stress effectief te beheersen.
Van trainingsplannen op maat tot dagelijkse gewoontebegeleiding \u{2013} ik help je gefocust en verantwoordelijk te blijven. 
Dagelijkse overwinningen vormen langdurige transformatie. Let\u{2019}s go!`,
        onlineCoaching: "Online Coaching. Echte Resultaten.",
        onlineCoachingModalText: `Waar je ook bent, je krijgt de begeleiding en motivatie die je nodig hebt om op koers te blijven en je fitnessdoelen te bereiken.
Met gestructureerde check-ins, flexibele plannen en persoonlijke betrokkenheid is online coaching net zo effectief als fysiek \u{2014} misschien zelfs meer.
Altijd ondersteuning, altijd richting, altijd resultaat.`,
        workouts: "Op Maat Gemaakte Trainingsschema\u2019s voor Echte Groei",
        workoutsModalText: `Structuur en strategie zijn essentieel \u{2014} en precies dat krijg je hier.
Of je nu traint voor prestaties, esthetiek of persoonlijke doelen: jouw schema wordt volledig afgestemd op jouw lichaam, tijd en ambitie.
Progressieve overload, gebalanceerde splits en slimme opbouw \u{2013} voor blijvend resultaat, geen stilstand.`,
        mealPlans: "Maaltijdschema\u2019s die je Doelen Voeden",
        mealPlansModalText: `Voeding hoort jouw bondgenoot te zijn, geen obstakel.
Met wetenschappelijk onderbouwde schema\u{2019}s afgestemd op vetverlies, spiergroei of wedstrijdvoorbereiding, weet je precies wat en waarom je eet.
Praktisch, voedzaam, haalbaar \u{2013} zonder crashdi\xebten of verwarring.`,
        nutritions: "Supplementadvies & Voeding die Werkt voor Jou",
        nutritionsModalText: `Supplementen en macro\u{2019}s hoeven geen doolhof te zijn.
Ik geef je advies op basis van wetenschap en ervaring, afgestemd op jouw levensstijl en fysieke behoeften.
Van timing tot dosering \u{2013} alles wordt begrijpelijk en effectief gemaakt.`,
        recipes: "Gezonde Recepten die \xc9cht Lekker Zijn",
        recipesModalText: `Gezond eten mag nooit saai zijn. 
Deze recepten zijn ontworpen om jouw fysieke doelen te ondersteunen en tegelijkertijd smaakvol en eenvoudig te blijven.
Snelle maaltijden, slimme variaties \u{2013} voeding waar je naar uitkijkt \xe9n op kunt bouwen.`
    }
};


const $dc49049c11e93abe$export$562e0893fdbd90ef = (lang)=>{
    const t = (0, $ccc968e822ac6427$export$150b732325d14d04)[lang] || {};
    const set = (attr, fn)=>document.querySelectorAll(`[${attr}]`).forEach((el)=>{
            const key = el.getAttribute(attr);
            if (t[key]) fn(el, t[key]);
        });
    set("data-i18n", (el, val)=>el.textContent = val);
    set("data-i18n-placeholder", (el, val)=>el.setAttribute("placeholder", val));
};
const $dc49049c11e93abe$export$335adc5d57a6b816 = ()=>{
    const languageSelect = document.getElementById("languageSelect");
    if (languageSelect) {
        languageSelect.addEventListener("change", (e)=>$dc49049c11e93abe$export$562e0893fdbd90ef(e.target.value));
        $dc49049c11e93abe$export$562e0893fdbd90ef(languageSelect.value);
    }
};


//This module handles the scroll effects for the website, including the back-to-top button and scroll progress indicator.
let $1f1cfd230038968c$var$ticking = false;
let $1f1cfd230038968c$var$backToTopTimeout;
function $1f1cfd230038968c$export$b1d36e16baf6bd28() {
    const backToTop = document.getElementById("backToTop");
    const scrollIndicator = document.getElementById("scroll-indicator");
    backToTop.addEventListener("click", ()=>{
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    });
    window.addEventListener("scroll", ()=>{
        if (!$1f1cfd230038968c$var$ticking) {
            window.requestAnimationFrame(()=>{
                const scrollTop = window.scrollY || window.pageYOffset;
                const totalScrollable = document.documentElement.scrollHeight - document.documentElement.clientHeight;
                const percent = totalScrollable > 0 ? scrollTop / totalScrollable * 100 : 0;
                scrollIndicator.style.width = percent.toFixed(2) + "%";
                if (scrollTop > 300) {
                    backToTop.classList.remove("opacity-0", "invisible");
                    backToTop.classList.add("opacity-100", "visible", "appear");
                    clearTimeout($1f1cfd230038968c$var$backToTopTimeout);
                    $1f1cfd230038968c$var$backToTopTimeout = setTimeout(()=>{
                        backToTop.classList.add("opacity-0", "invisible");
                        backToTop.classList.remove("opacity-100", "visible");
                    }, 4000);
                } else {
                    backToTop.classList.add("opacity-0", "invisible");
                    backToTop.classList.remove("opacity-100", "visible");
                    clearTimeout($1f1cfd230038968c$var$backToTopTimeout);
                }
                $1f1cfd230038968c$var$highlightActiveSection();
                $1f1cfd230038968c$var$ticking = false;
            });
            $1f1cfd230038968c$var$ticking = true;
        }
    });
}
function $1f1cfd230038968c$var$highlightActiveSection() {
    const sections = document.querySelectorAll("main section[id]");
    let currentId = "";
    sections.forEach((section, index)=>{
        const rect = section.getBoundingClientRect();
        const offset = 100;
        const isLast = index === sections.length - 1;
        if (rect.top <= offset && rect.bottom > offset || isLast && rect.top <= window.innerHeight && rect.bottom <= window.innerHeight) currentId = section.id;
    });
    document.querySelectorAll('nav a[href^="#"]').forEach((link)=>{
        link.classList.remove("text-pink-500");
        if (link.getAttribute("href") === `#${currentId}`) link.classList.add("text-pink-500");
    });
}


//This module handles the hamburger menu functionality for mobile navigation.
function $2a90bc7932e3a8bb$export$b64a6c5f3f6fc4ee() {
    const hamburger = document.getElementById("hamburger");
    const navLinks = document.getElementById("navLinks");
    if (!hamburger || !navLinks) return;
    hamburger.addEventListener("click", ()=>{
        hamburger.classList.toggle("open");
        navLinks.classList.toggle("open");
    });
    navLinks.addEventListener("click", (e)=>{
        if (e.target.tagName === "A") {
            hamburger.classList.remove("open");
            navLinks.classList.remove("open");
        }
    });
    document.addEventListener("click", (e)=>{
        const isClickInsideMenu = navLinks.contains(e.target);
        const isClickOnHamburger = hamburger.contains(e.target);
        if (!isClickInsideMenu && !isClickOnHamburger && navLinks.classList.contains("open")) {
            hamburger.classList.remove("open");
            navLinks.classList.remove("open");
        }
    });
}


//This module handles the smooth scrolling functionality for anchor links on the page.
function $870028e82d67aef5$export$22e4029a4c2fac28() {
    document.querySelectorAll('a[href^="#"]').forEach((anchor)=>{
        anchor.addEventListener("click", function(e) {
            e.preventDefault();
            const target = document.querySelector(this.getAttribute("href"));
            if (target) {
                const yOffset = -60;
                const y = target.getBoundingClientRect().top + window.pageYOffset + yOffset;
                window.scrollTo({
                    top: y,
                    behavior: "smooth"
                });
            }
        });
    });
}


// This module handles the fade-in effect for sections on the page.
function $f4a5a5de94561dcd$export$b8041cc5d94c81a5() {
    const fadeSections = document.querySelectorAll(".fade-section");
    const fadeObserver = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                entry.target.classList.add("visible");
                fadeObserver.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0.2
    });
    fadeSections.forEach((section)=>fadeObserver.observe(section));
}


//This module is responsible for the counter animation on the stats section of the page
let $4d23dd6fd503f373$var$hasCounted = false;
function $4d23dd6fd503f373$export$8718aa02886ccbc7() {
    const statsSection = document.getElementById("stats");
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) $4d23dd6fd503f373$var$animateCounters();
        });
    }, {
        threshold: 0.5
    });
    if (statsSection) observer.observe(statsSection);
}
function $4d23dd6fd503f373$var$animateCounters() {
    if ($4d23dd6fd503f373$var$hasCounted) return;
    $4d23dd6fd503f373$var$hasCounted = true;
    const counters = document.querySelectorAll(".counter");
    counters.forEach((counter)=>{
        const updateCount = ()=>{
            const target = +counter.getAttribute("data-target");
            const count = +counter.innerText;
            const increment = target / 100;
            if (count < target) {
                counter.innerText = Math.ceil(count + increment);
                setTimeout(updateCount, 30);
            } else counter.innerText = target;
        };
        updateCount();
    });
}


// This module handles the creation and functionality of a modal for displaying service information

// Helper function to get the current language from the <select>
const $6a217de5732b1725$var$getCurrentLang = ()=>document.getElementById("languageSelect")?.value || "en";
function $6a217de5732b1725$export$a1ce1850f5f6dd63() {
    const modal = document.createElement("div");
    modal.id = "serviceModal";
    modal.className = "fixed inset-0 bg-black bg-opacity-70 backdrop-blur-md flex items-center justify-center z-50 hidden";
    // Set the modal's inner HTML
    modal.innerHTML = `
    <div class="bg-gray-900 text-white rounded-xl p-6 max-w-2xl w-full mx-4 border border-pink-600 shadow-xl relative animate-fade-in-up">
      <button id="closeModal" class="absolute top-2 right-2 text-pink-500 text-2xl font-bold hover:text-pink-400">&times;</button>
      <h2 class="text-2xl font-bold text-pink-500 mb-4 text-center" id="modalTitle">Title</h2>
      <p class="text-gray-300 text-sm leading-relaxed" id="modalDescription">Description</p>
    </div>
  `;
    //Later for the images in the innerHTML
    // <img src="" alt="" id="modalImage" class="mb-4 rounded-lg shadow max-h-48 object-cover w-full" />
    // Add the modal to the page
    document.body.appendChild(modal);
    // Add close functionality to the modal
    document.getElementById("closeModal").addEventListener("click", ()=>{
        modal.classList.add("hidden");
    });
}
function $6a217de5732b1725$export$140f5e93270a7eba(data) {
    const modal = document.getElementById("serviceModal");
    if (!modal || !data?.key) return;
    const lang = $6a217de5732b1725$var$getCurrentLang();
    const key = data.key;
    const title = (0, $ccc968e822ac6427$export$150b732325d14d04)[lang][key];
    const description = (0, $ccc968e822ac6427$export$150b732325d14d04)[lang][`${key}ModalText`];
    const titleEl = document.getElementById("modalTitle");
    const descEl = document.getElementById("modalDescription");
    //Later for the images in the modal
    // const imageEl = document.getElementById("modalImage");
    // Apply content
    titleEl.textContent = title || `[Missing: ${key}]`;
    descEl.textContent = description || `[Missing: ${key}Text]`;
    //Later for the images in the modal
    // imageEl.src = data.image || "";
    // Optional: set i18n attributes for future language switching
    // titleEl.setAttribute("data-i18n", key);
    // descEl.setAttribute("data-i18n", `${key}Text`);
    // Show modal
    modal.classList.remove("hidden");
    // Store current modal data globally for retranslation support
    window.currentServiceModal = data;
} //Later for the images in the innerHTML
 // <img src="" alt="" id="modalImage" class="mb-4 rounded-lg shadow max-h-48 object-cover w-full" />


const $b6fab42de28362bc$export$57d6327b64ba721e = [
    "lifestyle",
    "onlineCoaching",
    "workouts",
    "mealPlans",
    "nutritions",
    "recipes"
].reduce((acc, key)=>{
    acc[key] = {
        key: key,
        image: `/Images/${key}.jpg`
    };
    return acc;
}, {});


//This module handles the hero section animation for the website
//This module handles the logo break effect animation for the website
function $aaaf13b78e515371$export$8c4aad548b5c0d89() {
    const imgElement = document.getElementById("logo-overlay");
    if (!imgElement) return;
    // Get position and size
    const rect = imgElement.getBoundingClientRect();
    const imageWidth = rect.width;
    const imageHeight = rect.height;
    const clickPosition = [
        imageWidth / 2,
        imageHeight / 2
    ];
    const container = document.createElement("div");
    container.style.position = "absolute";
    container.style.top = `${rect.top + window.scrollY - (imageHeight - rect.height) / 2}px`;
    container.style.left = `${rect.left + window.scrollX - (imageWidth - rect.width) / 2}px`;
    container.style.width = `${imageWidth}px`;
    container.style.height = `${imageHeight}px`;
    container.style.pointerEvents = "none";
    container.style.zIndex = 9999;
    container.style.overflow = "visible";
    container.style.perspective = "1000px";
    document.body.appendChild(container);
    container.style.zIndex = 0;
    // Hide original image
    imgElement.style.opacity = 0;
    let image;
    let vertices = [], indices = [], fragments = [];
    imgElement.decode().then(()=>{
        image = imgElement;
        triangulate();
        shatter();
    });
    function triangulate() {
        const TWO_PI = Math.PI * 2;
        const rings = [
            {
                r: 50,
                c: 12
            },
            {
                r: 150,
                c: 12
            },
            {
                r: 300,
                c: 12
            },
            {
                r: 1200,
                c: 12
            }
        ];
        const centerX = clickPosition[0];
        const centerY = clickPosition[1];
        vertices.push([
            centerX,
            centerY
        ]);
        rings.forEach((ring)=>{
            for(let i = 0; i < ring.c; i++){
                const angle = i / ring.c * TWO_PI;
                const radius = ring.r;
                const variance = radius * 0.25;
                const x = Math.cos(angle) * radius + centerX + randomRange(-variance, variance);
                const y = Math.sin(angle) * radius + centerY + randomRange(-variance, variance);
                vertices.push([
                    clamp(x, 0, imageWidth),
                    clamp(y, 0, imageHeight)
                ]);
            }
        });
        indices = Delaunay.triangulate(vertices);
    }
    function shatter() {
        for(let i = 0; i < indices.length; i += 3){
            const p0 = vertices[indices[i]];
            const p1 = vertices[indices[i + 1]];
            const p2 = vertices[indices[i + 2]];
            const fragment = new Fragment(p0, p1, p2);
            const dx = fragment.centroid[0] - clickPosition[0];
            const dy = fragment.centroid[1] - clickPosition[1];
            const d = Math.sqrt(dx * dx + dy * dy);
            const delay = d * 0.003 * randomRange(0.9, 1.1);
            gsap.to(fragment.canvas, {
                z: 500,
                rotationX: 30 * Math.sign(dy),
                rotationY: 90 * -Math.sign(dx),
                opacity: 1,
                duration: 1.5,
                delay: delay,
                ease: "power2.in",
                onComplete: ()=>container.removeChild(fragment.canvas)
            });
            container.appendChild(fragment.canvas);
            fragments.push(fragment);
        }
        // Clean up container after anim
        setTimeout(()=>{
            document.body.removeChild(container);
        }, 3000);
    }
    class Fragment {
        constructor(v0, v1, v2){
            this.v0 = v0;
            this.v1 = v1;
            this.v2 = v2;
            this.computeBox();
            this.computeCentroid();
            this.createCanvas();
            this.clip();
        }
        computeBox() {
            const xMin = Math.min(this.v0[0], this.v1[0], this.v2[0]);
            const xMax = Math.max(this.v0[0], this.v1[0], this.v2[0]);
            const yMin = Math.min(this.v0[1], this.v1[1], this.v2[1]);
            const yMax = Math.max(this.v0[1], this.v1[1], this.v2[1]);
            this.box = {
                x: xMin,
                y: yMin,
                w: xMax - xMin,
                h: yMax - yMin
            };
        }
        computeCentroid() {
            this.centroid = [
                (this.v0[0] + this.v1[0] + this.v2[0]) / 3,
                (this.v0[1] + this.v1[1] + this.v2[1]) / 3
            ];
        }
        createCanvas() {
            const canvas = document.createElement("canvas");
            canvas.width = this.box.w;
            canvas.height = this.box.h;
            canvas.style.position = "absolute";
            canvas.style.left = this.box.x + "px";
            canvas.style.top = this.box.y + "px";
            canvas.style.pointerEvents = "none";
            this.canvas = canvas;
            this.ctx = canvas.getContext("2d");
        }
        clip() {
            this.ctx.translate(-this.box.x, -this.box.y);
            this.ctx.beginPath();
            this.ctx.moveTo(this.v0[0], this.v0[1]);
            this.ctx.lineTo(this.v1[0], this.v1[1]);
            this.ctx.lineTo(this.v2[0], this.v2[1]);
            this.ctx.closePath();
            this.ctx.clip();
            this.ctx.drawImage(image, 0, 0, imageWidth, imageHeight);
        }
    }
    function clamp(x, min, max) {
        return Math.max(min, Math.min(x, max));
    }
    function randomRange(min, max) {
        return min + Math.random() * (max - min);
    }
}


function $a437ffe6360cce87$export$1391212d75b2ee65(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}


async function $6336cdaeb24d16de$export$69d323de27e64def() {
    const logo = document.getElementById("logo-overlay");
    const textContainer = document.getElementById("hero-text");
    const video = document.getElementById("hero-video");
    // Ensure required elements exist
    if (!logo || !textContainer || !video) return;
    // Start video from a specific timestamp
    video.currentTime = 2;
    video.play();
    // 1. Animate logo entry
    logo.classList.add("animate-logo-enter");
    // 2. Wait ~2.8s before triggering break effect
    await (0, $a437ffe6360cce87$export$1391212d75b2ee65)(2800);
    (0, $aaaf13b78e515371$export$8c4aad548b5c0d89)();
    // 3. Wait a bit more before removing the logo completely from DOM
    await (0, $a437ffe6360cce87$export$1391212d75b2ee65)(200);
    logo.remove(); // clean removal
    // 4. Finally, reveal the hero text with fade-in effect
    await (0, $a437ffe6360cce87$export$1391212d75b2ee65)(1300);
    textContainer.classList.remove("opacity-0");
    textContainer.classList.add("animate-text-in");
}


document.addEventListener("DOMContentLoaded", ()=>{
    (0, $6336cdaeb24d16de$export$69d323de27e64def)();
});
(0, $dc49049c11e93abe$export$335adc5d57a6b816)();
(0, $1f1cfd230038968c$export$b1d36e16baf6bd28)();
(0, $2a90bc7932e3a8bb$export$b64a6c5f3f6fc4ee)();
(0, $870028e82d67aef5$export$22e4029a4c2fac28)();
(0, $f4a5a5de94561dcd$export$b8041cc5d94c81a5)();
(0, $4d23dd6fd503f373$export$8718aa02886ccbc7)();
(0, $6a217de5732b1725$export$a1ce1850f5f6dd63)();
document.getElementById("year").textContent = new Date().getFullYear();
document.querySelectorAll("[data-service]").forEach((el)=>{
    el.addEventListener("click", ()=>{
        const key = el.dataset.service;
        (0, $6a217de5732b1725$export$140f5e93270a7eba)((0, $b6fab42de28362bc$export$57d6327b64ba721e)[key]);
    });
});

})();
//# sourceMappingURL=David_Vagusz_landing.a812de0a.js.map
